<main class="videos-page">
  <div class="container">
    <h1>{{ 'pages.ressources.contenus-videos.contenus-videos.text001' | translate }}</h1>
    <p class="subtitle">{{ 'pages.ressources.contenus-videos.contenus-videos.text002' | translate }}</p>

    @if (isLoading) {
      <div class="loading-state">
        <p>{{ 'pages.ressources.contenus-videos.contenus-videos.text003' | translate }}</p>
      </div>
    }

    @if (errorMessage) {
      <div class="error-state">
        <p>{{ errorMessage | translate }}</p>
      </div>
    }

    @if (!isLoading && !errorMessage) {
      <!-- GRANDE SECTION DU LECTEUR PRINCIPAL (MIS EN AVANT) -->
      @if (featuredVideo) {
        <div class="featured-video-section">
          <h2>{{ 'pages.ressources.contenus-videos.contenus-videos.text004' | translate }}</h2>
          <div class="featured-video-wrapper">
            <iframe 
              [src]="getSafeVideoUrl(featuredVideo.id)" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen>
            </iframe>
          </div>
          <div class="featured-video-info">
            <h3>{{ featuredVideo.title }}</h3>
            <p>{{ featuredVideo.date | date:'dd MMMM yyyy' }}</p>
          </div>
        </div>
      }

      <!-- GRILLE DES AUTRES VIDÉOS -->
      <div class="playlist-section">
        <h2 class="playlist-title">{{ 'pages.ressources.contenus-videos.contenus-videos.text005' | translate }}</h2>
        
        <div class="videos-grid">
          @for (video of paginatedItems; track video.id) {
            <div class="video-card" (click)="loadVideo(video.id)">
              <div class="video-thumbnail-wrapper">
                <img 
                  [src]="'https://img.youtube.com/vi/' + video.id + '/hqdefault.jpg'" 
                  [alt]="video.title" 
                  class="video-thumbnail">
                
                <div class="youtube-overlay-icon">
                  <svg height="100%" version="1.1" viewBox="0 0 68 48" width="100%">
                    <path d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,0.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.33,13.05,0,24,0,24s0.33,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.67,34.95,68,24,68,24S67.67,13.05,66.52,7.74z" fill="#f00"></path>
                    <path d="M 45,24 27,14 27,34 z" fill="#fff"></path>
                  </svg>
                </div>
              </div>
              <div class="video-info">
                <h3>{{ video.title }}</h3>
                <p>{{ video.date | date:'dd MMMM yyyy' }}</p>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</main>